import { buildApiUrl } from "../config/api";

function getOrCreateSessionId() {
  const key = "mayachitro_session_id";
  let sessionId = localStorage.getItem(key);

  if (!sessionId) {
    sessionId = `mc_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(key, sessionId);
  }

  return sessionId;
}

function getDeviceType() {
  const width = window.innerWidth;

  if (width <= 767) return "mobile";
  if (width <= 1024) return "tablet";
  return "desktop";
}

function getTrafficSource(referrerUrl, utmSource) {
  const text = `${utmSource || ""} ${referrerUrl || ""}`.toLowerCase();

  if (!text.trim()) return "Direct";
  if (text.includes("localhost")) return "Direct";
  if (text.includes("google")) return "Google";
  if (text.includes("facebook") || text.includes("fb.")) return "Facebook";
  if (text.includes("instagram")) return "Instagram";
  if (text.includes("pinterest")) return "Pinterest";
  if (text.includes("youtube") || text.includes("youtu.be")) return "YouTube";
  if (text.includes("etsy")) return "Etsy";
  if (text.includes("bing")) return "Bing";

  return "Referral";
}

async function trackVisitor() {
  try {
    const currentPath = window.location.pathname;

    const isAdminPage =
      currentPath.startsWith("/admin") ||
      currentPath.startsWith("/admin-login");

    if (isAdminPage) {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const referrerUrl = document.referrer || null;
    const utmSource = params.get("utm_source");

    const payload = {
      session_id: getOrCreateSessionId(),
      page_url: window.location.href,
      landing_page: `${window.location.origin}${currentPath}`,
      referrer_url: referrerUrl,
      source: getTrafficSource(referrerUrl, utmSource),

      utm_source: utmSource,
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
      utm_content: params.get("utm_content"),
      utm_term: params.get("utm_term"),

      device_type: getDeviceType(),
      screen_size: `${window.innerWidth}x${window.innerHeight}`,
      language: navigator.language || null,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
    };

    const response = await fetch(buildApiUrl("/analytics/track"), {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      let message = `Analytics request failed with HTTP ${response.status}`;

      try {
        const data = await response.json();
        if (data?.message) message = data.message;
      } catch {
        // The tracker is non-critical; an invalid error body should not affect the app.
      }

      console.warn("Visitor tracking skipped:", message);
    }
  } catch (error) {
    console.error("Visitor tracking failed:", error.message);
  }
}

export default trackVisitor;
